const image = {
    methods: {
        getImage(image) { 
            return image == null ? '/images/no-photo-male.jpg' : image
        },
    }
}

export default image;